<script setup lang="ts">
import CaretRightIcon from '@/assets/images/svg/caret-right.svg?component';
import type { TVulnerabilityDetails } from '@/_core/entities/vulnerability/models/types';
import type { TAppVersionReport, TSingleScanReport } from '@/_core/entities/report/models/types';
import { REPORT_ROUTE_NAMES } from '@/_core/entities/report/models/consts';
import { computed } from 'vue';

const props = defineProps<{
  vulnerabilityData: TVulnerabilityDetails;
  reportData: TAppVersionReport | TSingleScanReport;
  jobId?: string;
  integrationId?: string;
  branchName?: string;
  versionId?: string;
}>();

const isSingleScan = computed(() => !!props.jobId);

const topLabel = computed(() => {
  if (!isSingleScan.value) {
    return (props.reportData as TAppVersionReport).integrationName || props.reportData.fileName;
  }

  return props.reportData.fileName;
});

const topLink = computed(() => {
  if (!isSingleScan.value) {
    return {
      name: REPORT_ROUTE_NAMES.integrationBranch,
      params: { id: props.integrationId, branchName: props.branchName },
    };
  }

  return {
    name: REPORT_ROUTE_NAMES.singleScanReport,
    params: { jobId: props.jobId },
  };
});

const versionLink = computed(() => ({
  name: REPORT_ROUTE_NAMES.versionReport,
  params: {
    integrationId: props.integrationId,
    branchName: props.branchName,
    versionId: props.versionId,
  },
}));
</script>

<template>
  <div class="tw:pl-2.5 tw:flex tw:items-center tw:gap-2.5 tw:justify-start tw:overflow-x-auto">
    <div class="tw:flex tw:items-center tw:gap-1.5 tw:text-ghost tw:shrink-0">
      <router-link
        :to="topLink"
        class="tw:typography-small tw:text-ghost! tw:lg:hover:text-main-blue! tw:transition-colors tw:no-underline!"
        >{{ topLabel }}</router-link
      >
      <div class="tw:w-1.75 tw:grow-0">
        <CaretRightIcon />
      </div>
    </div>

    <template v-if="!isSingleScan">
      <div class="tw:flex tw:items-center tw:gap-1.5 tw:text-ghost tw:shrink-0">
        <router-link
          :to="versionLink"
          class="tw:typography-small tw:text-ghost! tw:lg:hover:text-main-blue! tw:transition-colors tw:no-underline!"
          >Version {{ reportData.version }}</router-link
        >
        <div class="tw:w-1.75 tw:grow-0">
          <CaretRightIcon />
        </div>
      </div>
    </template>

    <div class="tw:flex tw:gap-1 tw:shrink-0 tw:text-main-blue tw:typography-small">
      <div>{{ vulnerabilityData.category.descriptionTitle }}</div>
    </div>
  </div>
</template>
